import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { RUReservationsService } from '../ru-reservations.service';
import { RUReservations } from '../ru-reservations';

@Component({
    selector: 'app-ru-reservations',
    templateUrl: './ru-reservations.component.html',
    styleUrls: ['./ru-reservations.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class RUReservationsComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private ruReservationService: RUReservationsService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.ruReservation = data.ruReservation,
			this.statuses = ruReservationService.statuses;
	}

	@Input() ruReservation: RUReservations;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	ruReservationId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		ruReservationId: [],
		reservationId: [],
		statusId: [],
		propertyId: [],
		xmlApartmentId: [],
		dateFrom: [],
		dateTo: [],
		arrivalTime: [],
		numberOfGuests: [],
		ruPrice: [],
		clientPrice: [],
		alreadyPaid: [],
		resApaId: [],
		stayId: [],
		hotelId: [],
		roomId: [],
		rateId: [],
		policyText: [],
		name: [],
		surName: [],
		email: [],
		phone: [],
		skypeId: [],
		address: [],
		zipCode: [],
		countryId: [],
		languageId: [],
		numberOfAdults: [],
		numberOfChildren: [],
		numberOfInfants: [],
		age: [],
		creator: [],
		cancelTypeId: [],
		archived: [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole ruReservation object
		if (this.ruReservation) {
			this.ruReservationId = this.ruReservation.ruReservationId;
			if(this.ruReservation.dateFrom != undefined && this.ruReservation.dateFrom != null){
				this.ruReservation.dateFrom = moment.utc(this.ruReservation.dateFrom).format('MM/DD/YYYY');
			}
			if(this.ruReservation.dateTo != undefined && this.ruReservation.dateTo != null){
				this.ruReservation.dateTo = moment.utc(this.ruReservation.dateTo).format('MM/DD/YYYY');
			}
			if(this.ruReservation.arrivalTime != undefined && this.ruReservation.arrivalTime != null){
				this.ruReservation.arrivalTime = moment.utc(this.ruReservation.arrivalTime).format('MM/DD/YYYY');
			}
			this.fixDates();
			this.form1.patchValue(this.ruReservation);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.ruReservationId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.ruReservationService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ruReservation = res.data.ruReservation;
						this.doAdd.emit(this.ruReservation);
					},
					(err: any) => {
						console.log('ruReservation-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('ruReservation: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.ruReservationService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ruReservation = res.data.ruReservation;
						this.doUpdate.emit(this.ruReservation);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.ruReservationService.delete(this.ruReservation.ruReservationId)
				.subscribe(
					(res: any) => {
						console.log('ruReservation-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.ruReservation);
					},
					(err: any) => {
						console.log('ruReservation-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			ruReservationId: [this.ruReservationId],
			reservationId: [],
			statusId: [],
			propertyId: [],
			xmlApartmentId: [],
			dateFrom: [],
			dateTo: [],
			arrivalTime: [],
			numberOfGuests: [],
			ruPrice: [],
			clientPrice: [],
			alreadyPaid: [],
			resApaId: [],
			stayId: [],
			hotelId: [],
			roomId: [],
			rateId: [],
			policyText: [],
			name: [],
			surName: [],
			email: [],
			phone: [],
			skypeId: [],
			address: [],
			zipCode: [],
			countryId: [],
			languageId: [],
			numberOfAdults: [],
			numberOfChildren: [],
			numberOfInfants: [],
			age: [],
			creator: [],
			cancelTypeId: [],
			archived: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.ruReservation.ruReservationDate = moment(this.ruReservation.ruReservationDate).toDate();
	}
}
